module.exports = __webpack_public_path__ + "img/Aberdeen-FC.c6434682.png";